<script>
    export default {
        name: 'SyButtonItem',
        mounted() {
            this.$parent.buttons.push(this)
        },
        render(h) {
            return h('div', { style: { display: 'none' } })
        }
    }
</script>

<style lang="scss" scoped>

</style>
